import { Document } from '../../../providers/api/dtos';

/**
 * Checks if the given `document` exists.
 */
export const documentExists = (document?: Document): boolean => typeof document?.id !== 'undefined';
